import { adminServerInstance } from "../axios/instances";
import { 
    GET_LETIAN_STAFF_QT,
    GET_LETIAN_STAFF_QT_SUCCESS,
    GET_LETIAN_STAFF_QT_FAIL,
    QUICK_TRANSFER_ORDERS_QT,
    QUICK_TRANSFER_ORDERS_QT_SUCCESS,
    QUICK_TRANSFER_ORDERS_QT_FAIL,
    GET_LETIAN_STAFF_QT_TEMP,
    GET_LETIAN_STAFF_QT_TEMP_SUCCESS,
    GET_LETIAN_STAFF_QT_TEMP_FAIL,
    TRANSFER_PACKAGES_IN_RANGE_QT, 
    TRANSFER_PACKAGES_IN_RANGE_QT_SUCCESS, 
    TRANSFER_PACKAGES_IN_RANGE_QT_FAIL,
    TRANSFER_SUB_BATCH,
    TRANSFER_SUB_BATCH_SUCCESS,
    TRANSFER_SUB_BATCH_FAIL
 } from './types';

/**
 * @param {Object} params
 * @param {string} params.sub_batch_no
 * @param {string} params.sub_warehouse_id
 * @param {string} params.parent_warehouse_id
*/
export function transferSubBatch(params) {   
    return function(dispatch) {
        dispatch({type: TRANSFER_SUB_BATCH})
        return adminServerInstance.post(`/business/transfersubbatch`, params)
        .then(({data}) => {
            dispatch({
                type: TRANSFER_SUB_BATCH_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: TRANSFER_SUB_BATCH_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getLetianStaffTemp(city) {   
    return function(dispatch) {
        dispatch({type: GET_LETIAN_STAFF_QT_TEMP})
        return adminServerInstance.get(`/business/getletianstaff?city=${city}`)
        .then(({data}) => {
            dispatch({
                type: GET_LETIAN_STAFF_QT_TEMP_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: GET_LETIAN_STAFF_QT_TEMP_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

 export function getLetianStaff(city) {   
    return function(dispatch) {
        dispatch({type: GET_LETIAN_STAFF_QT})
        return adminServerInstance.get(`/business/getletianstaff?city=${city}`)
        .then(({data}) => {
            dispatch({
                type: GET_LETIAN_STAFF_QT_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: GET_LETIAN_STAFF_QT_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * @param {Object} params
 * @param {string} params.tnos
 * @param {string} params.driver_id
 * @param {string} params.operator
*/
export function quickTransferOrders(params) {   
    return (dispatch) => {
        dispatch( {type: QUICK_TRANSFER_ORDERS_QT} )
        return adminServerInstance.post(`/business/quicktransferorders`, params)
        .then(({data}) => {
            dispatch({
                type: QUICK_TRANSFER_ORDERS_QT_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: QUICK_TRANSFER_ORDERS_QT_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export const transferPackagesInRange = (subBatch, routeNo, start, end, receiver,pickupModel) => {
    return (dispatch) => {
        dispatch( {type: TRANSFER_PACKAGES_IN_RANGE_QT} );
        return adminServerInstance.post(`/cargo/transferpackagesinrange`, {
            sub_batch: subBatch, 
            route_no: routeNo, 
            start: start, 
            end: end, 
            receiver: receiver,
            pickup_model: pickupModel
        })
        .then(({data}) => {
            dispatch({
                type: TRANSFER_PACKAGES_IN_RANGE_QT_SUCCESS,
                payload: data.data
            });
            return Promise.resolve(data.data);
        }).catch((error) => {
            dispatch({
                type: TRANSFER_PACKAGES_IN_RANGE_QT_FAIL,
                payload: error
            });
            return Promise.reject(error);
        });
    };
};